import { BackgroundCheckStatus } from "@wingspanhq/wingspan-api-sdk";

import {
  StepItem,
  StepsProps
} from "../../../../../../shared/components/Steps";

export const getBackgroundCheckProgressSteps = (
  status: BackgroundCheckStatus
): StepItem[] => {
  const allStepsCombinations: Record<
    BackgroundCheckStatus,
    StepsProps["steps"]
  > = {
    [BackgroundCheckStatus.SUCCESS]: [
      {
        title: "Start",
        status: "Complete"
      },
      {
        title: "Processed",
        status: "Complete"
      },
      {
        title: "Complete",
        status: "Complete"
      }
    ],
    [BackgroundCheckStatus.PROCESSING]: [
      {
        title: "Start",
        status: "Complete"
      },
      {
        title: "Processed",
        status: "Active"
      },
      {
        title: "Complete",
        status: "Pending"
      }
    ],
    [BackgroundCheckStatus.NEW]: [
      {
        title: "Start",
        status: "Pending"
      },
      {
        title: "Processed",
        status: "Pending"
      },
      {
        title: "Complete",
        status: "Pending"
      }
    ],
    [BackgroundCheckStatus.PENDING]: [
      {
        title: "Start",
        status: "Active"
      },
      {
        title: "Processed",
        status: "Pending"
      },
      {
        title: "Complete",
        status: "Pending"
      }
    ],
    [BackgroundCheckStatus.FAILED]: [
      {
        title: "Start",
        status: "Failed"
      },
      {
        title: "Processed",
        status: "Failed"
      },
      {
        title: "Complete",
        status: "Pending"
      }
    ]
  };

  return allStepsCombinations[status];
};
